// Metadata for all 32 calculators. Keywords are used for the live search.
export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "body", label: "Body Composition" },
  { id: "nutrition", label: "Nutrition & Diet" },
  { id: "fitness", label: "Fitness & Performance" },
  { id: "womens", label: "Women's Health & Pregnancy" },
  { id: "medical", label: "Medical" },
  { id: "general", label: "General" },
];

export const CALCULATORS = [
  // General
  {
    slug: "age-calculator",
    name: "Age Calculator",
    category: "general",
    icon: "Cake",
    description: "Find exact age in years, months and days.",
    keywords: ["age", "birthday", "date", "years old", "date of birth"],
    componentKey: "AgeCalculator",
  },

  // Body Composition (9)
  {
    slug: "bmi-calculator",
    name: "BMI Calculator",
    category: "body",
    icon: "Scale",
    description: "Body Mass Index from height and weight.",
    keywords: ["bmi", "body mass index", "weight loss", "healthy weight", "overweight", "obesity"],
    componentKey: "BmiCalculator",
  },
  {
    slug: "body-fat-calculator",
    name: "Body Fat Calculator",
    category: "body",
    icon: "Percent",
    description: "Estimate body fat % (U.S. Navy method).",
    keywords: ["body fat", "navy", "percent fat", "adiposity"],
    componentKey: "BodyFatCalculator",
  },
  {
    slug: "army-body-fat-calculator",
    name: "Army Body Fat Calculator",
    category: "body",
    icon: "Shield",
    description: "U.S. Army tape-test body fat estimate.",
    keywords: ["army", "military", "body fat", "tape test", "pass fail"],
    componentKey: "ArmyBodyFatCalculator",
  },
  {
    slug: "ideal-weight-calculator",
    name: "Ideal Weight Calculator",
    category: "body",
    icon: "Target",
    description: "Devine, Robinson, Miller & Hamwi formulas.",
    keywords: ["ideal weight", "goal weight", "devine", "robinson", "miller", "hamwi"],
    componentKey: "IdealWeightCalculator",
  },
  {
    slug: "lean-body-mass-calculator",
    name: "Lean Body Mass Calculator",
    category: "body",
    icon: "Dumbbell",
    description: "Estimate LBM and fat mass (Boer formula).",
    keywords: ["lean body mass", "lbm", "muscle", "fat free mass", "boer"],
    componentKey: "LeanBodyMassCalculator",
  },
  {
    slug: "healthy-weight-calculator",
    name: "Healthy Weight Calculator",
    category: "body",
    icon: "HeartPulse",
    description: "Healthy weight range for your height.",
    keywords: ["healthy weight", "bmi range", "normal weight"],
    componentKey: "HealthyWeightCalculator",
  },
  {
    slug: "body-type-calculator",
    name: "Body Type Calculator",
    category: "body",
    icon: "User",
    description: "Ectomorph, Mesomorph or Endomorph estimate.",
    keywords: ["body type", "somatotype", "ectomorph", "mesomorph", "endomorph", "frame size"],
    componentKey: "BodyTypeCalculator",
  },
  {
    slug: "anorexic-bmi-calculator",
    name: "Anorexic BMI Calculator",
    category: "body",
    icon: "AlertTriangle",
    description: "Flags severe underweight (BMI < 17.5).",
    keywords: ["anorexic bmi", "severe underweight", "eating disorder"],
    componentKey: "AnorexicBmiCalculator",
  },
  {
    slug: "overweight-calculator",
    name: "Overweight Calculator",
    category: "body",
    icon: "TrendingDown",
    description: "How much to lose to reach a healthy BMI.",
    keywords: ["overweight", "weight loss", "how much to lose", "obesity"],
    componentKey: "OverweightCalculator",
  },

  // Nutrition & Diet (8)
  {
    slug: "calorie-calculator",
    name: "Calorie Calculator",
    category: "nutrition",
    icon: "Flame",
    description: "Daily calories for maintenance, loss or gain.",
    keywords: ["calorie", "calories", "weight loss", "diet", "tdee", "maintenance"],
    componentKey: "CalorieCalculator",
  },
  {
    slug: "bmr-calculator",
    name: "BMR Calculator",
    category: "nutrition",
    icon: "Zap",
    description: "Basal Metabolic Rate (Mifflin-St Jeor).",
    keywords: ["bmr", "basal metabolic rate", "metabolism", "resting"],
    componentKey: "BmrCalculator",
  },
  {
    slug: "tdee-calculator",
    name: "TDEE Calculator",
    category: "nutrition",
    icon: "Activity",
    description: "Total Daily Energy Expenditure.",
    keywords: ["tdee", "total daily energy", "activity level", "calories burned"],
    componentKey: "TdeeCalculator",
  },
  {
    slug: "macro-calculator",
    name: "Macro Calculator",
    category: "nutrition",
    icon: "PieChart",
    description: "Split calories into protein, carbs & fat.",
    keywords: ["macro", "macronutrients", "protein", "carbs", "fat", "keto", "iifym"],
    componentKey: "MacroCalculator",
  },
  {
    slug: "protein-calculator",
    name: "Protein Calculator",
    category: "nutrition",
    icon: "Beef",
    description: "Daily protein intake target.",
    keywords: ["protein", "muscle", "grams protein", "diet"],
    componentKey: "ProteinCalculator",
  },
  {
    slug: "fat-intake-calculator",
    name: "Fat Intake Calculator",
    category: "nutrition",
    icon: "Droplet",
    description: "Daily fat range from your calorie target.",
    keywords: ["fat intake", "dietary fat", "grams fat"],
    componentKey: "FatIntakeCalculator",
  },
  {
    slug: "carbohydrate-calculator",
    name: "Carbohydrate Calculator",
    category: "nutrition",
    icon: "Wheat",
    description: "Daily carb range from your calorie target.",
    keywords: ["carbs", "carbohydrate", "grams carbs"],
    componentKey: "CarbohydrateCalculator",
  },
  {
    slug: "weight-watcher-points-calculator",
    name: "Weight Watcher Points Calculator",
    category: "nutrition",
    icon: "Cookie",
    description: "Estimated WW-style points per food.",
    keywords: ["weight watchers", "ww", "smartpoints", "points"],
    componentKey: "WeightWatcherPointsCalculator",
  },

  // Fitness & Performance (4)
  {
    slug: "pace-calculator",
    name: "Pace Calculator",
    category: "fitness",
    icon: "Timer",
    description: "Running pace + race finish predictions.",
    keywords: ["pace", "running", "race", "marathon", "5k", "10k", "half marathon"],
    componentKey: "PaceCalculator",
  },
  {
    slug: "calories-burned-calculator",
    name: "Calories Burned Calculator",
    category: "fitness",
    icon: "Flame",
    description: "Calories burned by activity and duration.",
    keywords: ["calories burned", "exercise", "workout", "met"],
    componentKey: "CaloriesBurnedCalculator",
  },
  {
    slug: "one-rep-max-calculator",
    name: "One Rep Max Calculator",
    category: "fitness",
    icon: "Dumbbell",
    description: "Estimated 1RM + %1RM rep chart.",
    keywords: ["1rm", "one rep max", "strength", "lifting", "epley"],
    componentKey: "OneRepMaxCalculator",
  },
  {
    slug: "target-heart-rate-calculator",
    name: "Target Heart Rate Calculator",
    category: "fitness",
    icon: "HeartPulse",
    description: "Karvonen training-zone heart rates.",
    keywords: ["heart rate", "karvonen", "training zone", "cardio", "fat burn"],
    componentKey: "TargetHeartRateCalculator",
  },

  // Women's Health & Pregnancy (7)
  {
    slug: "pregnancy-calculator",
    name: "Pregnancy Calculator",
    category: "womens",
    icon: "Baby",
    description: "Current week, trimester and due date.",
    keywords: ["pregnancy", "gestation", "trimester", "how many weeks"],
    componentKey: "PregnancyCalculator",
  },
  {
    slug: "due-date-calculator",
    name: "Due Date Calculator",
    category: "womens",
    icon: "Calendar",
    description: "Estimated delivery date from LMP.",
    keywords: ["due date", "edd", "delivery date", "naegele"],
    componentKey: "DueDateCalculator",
  },
  {
    slug: "pregnancy-conception-calculator",
    name: "Pregnancy Conception Calculator",
    category: "womens",
    icon: "Sparkles",
    description: "Back-calculate estimated conception date.",
    keywords: ["conception", "when did i conceive", "pregnancy"],
    componentKey: "PregnancyConceptionCalculator",
  },
  {
    slug: "pregnancy-weight-gain-calculator",
    name: "Pregnancy Weight Gain Calculator",
    category: "womens",
    icon: "TrendingUp",
    description: "IOM recommended weekly weight gain.",
    keywords: ["pregnancy weight gain", "iom", "healthy pregnancy weight"],
    componentKey: "PregnancyWeightGainCalculator",
  },
  {
    slug: "ovulation-calculator",
    name: "Ovulation Calculator",
    category: "womens",
    icon: "Egg",
    description: "Predicted ovulation date + fertile window.",
    keywords: ["ovulation", "fertile window", "cycle", "period"],
    componentKey: "OvulationCalculator",
  },
  {
    slug: "conception-calculator",
    name: "Conception Calculator",
    category: "womens",
    icon: "Heart",
    description: "Best days to conceive from your cycle.",
    keywords: ["conception", "trying to conceive", "ttc", "fertile days"],
    componentKey: "ConceptionCalculator",
  },
  {
    slug: "period-calculator",
    name: "Period Calculator",
    category: "womens",
    icon: "Droplets",
    description: "Predicted next 6 period dates.",
    keywords: ["period", "menstrual", "cycle tracker", "next period"],
    componentKey: "PeriodCalculator",
  },

  // Medical (3)
  {
    slug: "gfr-calculator",
    name: "GFR Calculator",
    category: "medical",
    icon: "Stethoscope",
    description: "eGFR (CKD-EPI 2021) + kidney function stage.",
    keywords: ["gfr", "egfr", "kidney", "ckd", "creatinine", "ckd-epi"],
    componentKey: "GfrCalculator",
    disclaimer: true,
  },
  {
    slug: "body-surface-area-calculator",
    name: "Body Surface Area Calculator",
    category: "medical",
    icon: "Square",
    description: "BSA in m² (Mosteller formula).",
    keywords: ["bsa", "body surface area", "mosteller", "medical dosing"],
    componentKey: "BsaCalculator",
    disclaimer: true,
  },
  {
    slug: "bac-calculator",
    name: "BAC Calculator",
    category: "medical",
    icon: "Wine",
    description: "Estimated Blood Alcohol Content (Widmark).",
    keywords: ["bac", "blood alcohol", "widmark", "drinks", "legal limit"],
    componentKey: "BacCalculator",
    disclaimer: true,
  },
];

// Mark disclaimer-required calculators
["anorexic-bmi-calculator", "pregnancy-calculator", "due-date-calculator", "pregnancy-conception-calculator", "pregnancy-weight-gain-calculator", "ovulation-calculator", "conception-calculator", "period-calculator"].forEach((slug) => {
  const c = CALCULATORS.find((x) => x.slug === slug);
  if (c) c.disclaimer = true;
});

export const getBySlug = (slug) => CALCULATORS.find((c) => c.slug === slug);

export const getRelated = (slug, count = 4) => {
  const current = getBySlug(slug);
  if (!current) return [];
  const sameCat = CALCULATORS.filter((c) => c.category === current.category && c.slug !== slug);
  const others = CALCULATORS.filter((c) => c.category !== current.category && c.slug !== slug);
  return [...sameCat, ...others].slice(0, count);
};
